export interface IPackagePropertyApi {
  packageproperty_id: number;
  package_id?: number;
  key: string;
  value: string;
}

export default class PackageProperty {
  id: number;
  packageID: number;
  key: string;
  value: string;

  constructor(id: number, packageID: number, key: string, value: string) {
    this.id = id;
    this.packageID = packageID;
    this.key = key;
    this.value = value;
  }

  static fromApi(apiObject: IPackagePropertyApi): PackageProperty {
    return new PackageProperty(apiObject.packageproperty_id, apiObject.package_id, apiObject.key, apiObject.value);
  }

  toApi(): IPackagePropertyApi {
    const toReturn: IPackagePropertyApi = {
      packageproperty_id: this.id >= 0 ? this.id : undefined,
      key: this.key,
      value: this.value,
    };

    if (this.packageID !== null && this.packageID !== undefined) {
      toReturn.package_id = this.packageID;
    }

    return toReturn;
  }

  toString(): string {
    return `${this.key}: ${this.value}`;
  }
}
